import { KdsTextField } from "@kazaar-platform/design-system";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import { type ControlledTextFieldProps } from "./ControlledTextField.types";

const ControlledTextField = ({
  name,
  ...textFieldProps
}: ControlledTextFieldProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState();

  const error = errors[name];

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <KdsTextField
          {...textFieldProps}
          errorMessage={error?.message?.toString() || ""}
          hasError={!!error}
          value={field.value?.toString()}
          label={textFieldProps.label}
          onChange={field.onChange}
        />
      )}
    />
  );
};

export { ControlledTextField };
